import {Component, EventEmitter,Input, OnInit, Output} from '@angular/core';
import {NgbCalendar} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {ApiService} from '../../../../shared/services/api.service';




@Component({
  selector: 'datepicker-Miladi',
  templateUrl: './miladi-datepicker.html',
  styleUrls: ['./miladi-datepicker.css']
  // providers: [
  //   {provide: NgbCalendar, useClass: NgbCalendarPersian},
  //   {provide: NgbDatepickerI18n, useClass: NgbDatepickerI18nPersian}
  // ]
})

export class NgbDatepickerMiladiComponent implements OnInit {
  @Output() buttonClicked = new EventEmitter();
  id: number;
  @Input() lblText: any;
  @Input() newDate;
  @Input() model: any;
  date: { year: number, month: number };
  isDisabled = false;
  datemiladi;
  current = new Date();
  minDate = {
    year: this.current.getFullYear(),
    month: this.current.getMonth() + 1,
    day: this.current.getDate()
  };
  constructor(private calendar: NgbCalendar,
              private apiService: ApiService,
              public translate: TranslateService,) {


  }

  ngOnInit() {
    this.selectToday();
  }

  selectToday() {
    this.model = this.calendar.getToday();
  }

  onClick($event) {
    const miladi = Number($event.year) + '-' + Number($event.month) + '-' + Number($event.day)
    this.datemiladi = miladi.split('-');
    const UTCDate = new Date(Number(this.datemiladi[0]), Number(this.datemiladi[1]) - 1, Number(this.datemiladi[2]));
    this.newDate = UTCDate.getTime();
    this.buttonClicked.emit($event);
  }


}
